/* global satismeter process */
import { getUser, isEnterprisePlan, isAdmin } from '@/service/user'
import { isProduction } from '@/mixins/meta.js'
import moment from 'moment'
const env = window.env || process.env

const showSurvey = () => {
  // eslint-disable-next-line no-console
  console.log(`[TeamCulture] satismeter ${isProduction()}`)
  if (!isProduction()) return ''
  const {
    id,
    email,
    profile,
    plan,
    tenantName,
    companyName,
    companyCreatedAt,
  } = getUser()
  const has30days = () => moment().diff(companyCreatedAt, 'days') >= 30
  const canAnswer = isEnterprisePlan() && isAdmin() && has30days()
  // eslint-disable-next-line no-console
  console.log(`[TeamCulture] satismeter answer ${canAnswer}`)
  if (canAnswer && satismeter) {
    satismeter({
      writeKey: env.VUE_APP_SATISMETER_KEY,
      userId: id,
      traits: {
        name: `${profile.firstname} ${profile.lastname}`,
        email,
        createdAt: companyCreatedAt,
        tenantName,
        plan,
        companyName,
      },
    })
  }
}

export default {
  register: app => {
    app.$root.$on('app:satismeter:showSurvey', () => showSurvey(app))
  },
}
